import React from 'react';
import AnimatedSection from '../components/AnimatedSection';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-content">
            <h1>About us</h1>
            <p>
              It takes only 50 milliseconds for a user to form an opinion about a website that determines
              whether they stay or leave. In the era of the internet, it is more important than ever for a
              business to have an online presence to keep pace with the market.
            </p>
            <p>
              Founded by three software engineers, Solvr aims to help businesses modernize their
              websites to keep up in the digital age. Our services range from a simple informational
              website to a fully functional web application that will help your business thrive.
            </p>
            <p>
              With Will located in Chicago, Zafar located in Iowa City, and Subrat located in Raleigh, our
              expertise covers a lot of ground. However, if you are outside of these areas, do not hesitate to
              reach out, as we have designed websites for companies around the United States.
            </p>
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="founders">
        <div className="container">
          <AnimatedSection animationType="fadeInUp">
            <h2>Meet Our Founders</h2>
          </AnimatedSection>
          <AnimatedSection animationType="fadeInUp" delay={200}>
            <div className="founders-grid">
            <div className="founder-card">
              <div className="founder-image">
                <img src="/images/founders/will.jpg" alt="Will Hunnius" />
              </div>
              <div className="founder-info">
                <h3>Will Hunnius</h3>
                <p className="founder-title">Co-Founder & Lead Developer</p>
                <p>
                Will received his Bachelors Degree in Computer Science & Engineering from the University of Iowa
                and his Masters in Computer Science from the University of Illinois Urbana-Champaign.
                He is now working full time as a software engineer in Chicago for J.P Morgan Chase.
                </p>
                <div className="founder-links">
                  <a href="https://www.willhunnius.com/" target="_blank" rel="noopener noreferrer" className="personal-website-link">
                    Visit Will's Website
                  </a>
                </div>
              </div>
            </div>

            <div className="founder-card">
              <div className="founder-image">
                <img src="/images/founders/subrat.jpg" alt="Subrat Acharya" />
              </div>
              <div className="founder-info">
                <h3>Subrat Acharya</h3>
                <p className="founder-title">Co-Founder & Lead Developer</p>
                <p>
                Subrat Received his Bachelor's Degree in Biomedical Engineering from the University of Iowa.
                After completing his degree, he decided to instead pursue his passion for software and is now
                working as a full-time software engineer for Avantor Inc.
                </p>
                <div className="founder-links">
                  <a href="https://subratacharya99.github.io/my_website/" target="_blank" rel="noopener noreferrer" className="personal-website-link">
                    Visit Subrat's Website
                  </a>
                </div>
              </div>
            </div>

            <div className="founder-card">
              <div className="founder-image">
                <img src="/images/founders/zafar.jpg" alt="Zafar Khan" />
              </div>
              <div className="founder-info">
                <h3>Zafar Khan</h3>
                <p className="founder-title">Co-Founder & Lead Developer</p>
                <p>
                Zafar received his Bachelor's Degree in Computer Science & Engineering from the University of Iowa,
                and his Masters in Software Engineering from Pennsylvania State University.
                After completing his education, Zafar is now working full time at Wabtec Corporation.
                </p>
                <div className="founder-links">
                  <a href="https://zafak.github.io" target="_blank" rel="noopener noreferrer" className="personal-website-link">
                    Visit Zafar's Website
                  </a>
                </div>
              </div>
            </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>
  );
};

export default About; 